import type { IconData } from '@stacksjs/iconify-core'

export const phoneRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M34.431 1a5 5 0 0 0-4.642 3.143l-2.466 6.165a6 6 0 0 0 1.328 6.471l3.048 3.048A18.05 18.05 0 0 1 19.827 31.7l-3.048-3.048a6 6 0 0 0-6.47-1.328L4.143 29.79A5 5 0 0 0 1 34.43V35c0 6.627 5.373 12 12 12h.5c18.134 0 32.902-14.407 33.482-32.4q.018-.133.018-.268V13c0-6.627-5.373-12-12-12zm-.928 4.629A1 1 0 0 1 34.43 5H35a8 8 0 0 1 8 8v1.143a2 2 0 0 0-.01.161C42.563 30.224 29.522 43 13.5 43H13a8 8 0 0 1-8-8v-.569a1 1 0 0 1 .629-.928l6.165-2.466a2 2 0 0 1 2.157.442l3.076 3.077c.97.97 2.44 1.433 3.874.998A22.05 22.05 0 0 0 35.554 20.9c.435-1.433-.028-2.904-.998-3.874l-3.077-3.076a2 2 0 0 1-.443-2.157z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default phoneRemix
